module.exports = __webpack_public_path__ + "img/设计单-选中.b60ba034.png";